export const removeNeedlessZeros = (number: string) => {
  if (number.includes('.')) {
    return number.replace(/(0{1,})$/, '').replace(/\.$/, '');
  }
  return number;
};
